/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountComboGroupModifierSchema } from "./calculateDiscountComboGroupModifierSchema.ts";
import { calculateDiscountComboModifierSchema } from "./calculateDiscountComboModifierSchema.ts";
import { discountItemSchema } from "./discountItemSchema.ts";

export const calculateDiscountComboItemSchema = z
	.object({
		id: z.uuid(),
		amount: z.int().min(1),
		size: z.uuid().nullish(),
		modifiers: z.array(calculateDiscountComboModifierSchema).nullish(),
		group_modifiers: z.array(calculateDiscountComboGroupModifierSchema).nullish(),
		price: z.string(),
		base_price: z.string().describe("Цена за единицу без акции блюда; совпадает с price, если акции нет."),
		total_price: z.string(),
		new_price: z.string(),
		total_new_price: z.string(),
		discounts: z.array(discountItemSchema).nullable(),
	})
	.describe("Уменьшение стоимости модификаторов позиции на бесплатные единицы.");
